jQuery(document).ready(function ($) {

    if ($(".bloc_paras").length) {

        document.fonts.ready.then(() => {

            $( ".bloc_paras" ).each(function( index ) {

                var cible = $(this)

                let paragraphe = cible.find(".grid-1-small-1 .texte")

                var splitPara = new SplitText( paragraphe , {
                    type: "lines",
                    tag:'div',
                    reduceWhiteSpace:true,
                    linesClass: "line++"
                })


                gsap.from(splitPara.lines, {
                    opacity : 0,
                    y : 20 ,
                    duration : .6,
                    ease: "power1.out",
                    stagger : 0.1,
                    scrollTrigger: {
                        trigger: paragraphe,
                        markers: false,
                        start: "top 85%"
                    }
                })


            })

        })



    }

})